import axios from 'axios';
import { API_URL } from '../constants';
import APIKit from '../APIKit';

function addbank(api,payload) {
  
    return new Promise(async (resolve, reject) => {
      try {
        const userStorage = await getAuthAsyncStorage();
        if (userStorage.token) {
          payload.append('auth_token', userStorage.token);
        } else {
        }
      } catch (e) {
      }
  
      APIKit.post('/'+api, payload)
        .then(async (response) => {
          try {
  
            resolve(response.data);
          } catch (e) {
  
            reject(e);
          }
        })
        .catch((err) => {
  
          reject(err);
        });
    });
  }
  

  function banklist(api,payload) {
  
    return new Promise(async (resolve, reject) => {
      try {
        const userStorage = await getAuthAsyncStorage();
        if (userStorage.token) {
          payload.append('auth_token', userStorage.token);
        } else {
        }
      } catch (e) {
      }
  
      APIKit.post('/'+api, payload)
        .then(async (response) => {
          try {
  
            resolve(response.data);
          } catch (e) {
  
            reject(e);
          }
        })
        .catch((err) => {
  
          reject(err);
        });
    });
  }
  
  
  function createPaymentOrder(api, payload) {
  
    return new Promise(async (resolve, reject) => {
      try {
        const token = window.localStorage.getItem("auth_token");
        if (token) {
          payload.append('auth_token', token);
        }
      } catch (e) {
      }
  
      APIKit.post('/'+api, payload)
        .then(async (response) => {
          try {
  
            resolve(response.data);
          } catch (e) {
            reject(e);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  export const paymentService = {
    addbank,banklist,createPaymentOrder
  };